import type { AluminiumComposition, PETComposition } from 'api';
import { AIModelChoices } from 'api';
import { useTranslation } from 'i18n';
import { addError } from 'monitor';
import { Typography } from 'ui';

import { isPetBaledAiModel } from '../../../evidence/types';
import { PETCompositionBreakdown } from '../../index';
import { AluminiumCompositionBreakdown } from '../AluminiumCompositionBreakdown/AluminiumCompositionBreakdown';

type AluProps = {
  variant: 'alu' | 'briquette';
  aluminiumComposition: AluminiumComposition;
};

type PETProps = {
  variant: 'pet' | 'pet_dummy_bale' | 'pet_dummy_bale_2' | 'pet_envases';
  petComposition: PETComposition;
};

type Props = AluProps | PETProps;

const isPetProps = (props: Props): props is PETProps => isPetBaledAiModel(props.variant);

export const MaterialAiBreakdown = ({ ...props }: Props) => {
  const { t } = useTranslation('features');

  if (props.variant === AIModelChoices.alu || props.variant === AIModelChoices.briquette) {
    return <AluminiumCompositionBreakdown composition={props.aluminiumComposition} />;
  }

  if (isPetProps(props)) {
    return <PETCompositionBreakdown composition={props.petComposition} modelName={props.variant} />;
  }

  addError(Error(`Ai model ${props.variant} not supported.`));

  return <Typography>{t('backlog.breakdowns.materialAiBreakdown.aiModelNotSupported')}</Typography>;
};
